"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApOutsideClick = void 0;
var lodash_1 = require("lodash");
var React = require("react");
var setReactRef_1 = require("../../utils/setReactRef");
var ApOutsideClick = /** @class */ (function (_super) {
    __extends(ApOutsideClick, _super);
    function ApOutsideClick() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.roots = [];
        _this.onClickOutside = function (event) {
            if (!_this.roots.length) {
                return;
            }
            var target = event.target;
            // @ts-ignore
            var isInside = _this.roots.some(function (root) { return root.contains(target); });
            // Event targets can become detached from DOM before OutsideClick handles
            // the event. This is common on rerenders that result in removal of DOM nodes.
            // In these cases we cannot decide whether the element was inside the `roots`
            // or not.
            // Here we add an option for users to explicitly declare that the event.target
            // was inside roots by calling event.preventDefault().
            // TODO Revisit, find a cleaner solution.
            var wasInside = event.defaultPrevented && !document.contains(target);
            if (!isInside && !wasInside) {
                if (_this.props.shouldPreventDefault) {
                    event.preventDefault();
                }
                _this.props.onClick(event);
            }
        };
        return _this;
    }
    ApOutsideClick.prototype.componentDidMount = function () {
        document.addEventListener(this.props.event, this.onClickOutside, this.props.useCapture);
    };
    ApOutsideClick.prototype.componentWillUnmount = function () {
        document.removeEventListener(this.props.event, this.onClickOutside, this.props.useCapture);
    };
    ApOutsideClick.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, getClickRoots = _a.getClickRoots;
        var element = React.Children.only(children);
        if (!element) {
            return null;
        }
        // @ts-ignore
        return React.cloneElement(element, __assign(__assign({}, element.props), { ref: function (el) {
                var _a;
                // @ts-ignore
                _this.roots = lodash_1.compact(getClickRoots ? getClickRoots() : [el]);
                // Call the original ref, if any
                // @ts-ignore
                var ref = (_a = element.ref) !== null && _a !== void 0 ? _a : element.props.ref;
                if (ref) {
                    setReactRef_1.setReactRef(ref, el);
                }
            } }));
    };
    ApOutsideClick.defaultProps = {
        event: 'click',
        getClickRoots: null,
        shouldPreventDefault: true,
        useCapture: true,
    };
    return ApOutsideClick;
}(React.Component));
exports.ApOutsideClick = ApOutsideClick;
exports.default = ApOutsideClick;
//# sourceMappingURL=ApOutsideClick.js.map